module.exports = __webpack_public_path__ + "static/media/clients-04.9adf2aac.svg";